<!-- 优惠卷 -->

<template>
    <div class='maketing_box'>
        <div class="container" style="padding-bottom: 40px;">
            <div class="tabV">
                <div :class="idx == 0 ? 't2' : 't1'" @click="changeTab(0)">My coupons</div>
                <div :class="idx == 1 ? 't2' : 't1'" style="margin-left: 24px;" @click="changeTab(1)">Platform coupons</div>
            </div>

            <!-- 我的优惠卷列表 -->
            <!-- "status": "0", //状态（0-待使用、1-已使用、2-已过期） -->
            <div class="coupons" v-if="idx == 0">
                <div class="couponsT" :class="item.status == 2 ? 'couponsT1' : ''" v-for="(item, index) in myCouponList"
                    :key="index">
                    <div class="couponsTV">
                        <div class="top">
                            <div class="t1">{{ Number(item.subtractPrice) / Number(item.reachPrice) * 100 }}% OFF</div>
                            <div class="t2" v-if="item.status == '0'">unused coupon</div>
                            <div class="t22" v-if="item.status == '2' || item.status == '1'"></div>
                        </div>
                        <div class="t3">For orders over ${{ item.reachPrice }}</div>
                        <div style="height: 16px;"></div>
                        <div class="t4">
                            <div class="t41"></div>
                            <div class="t42">{{ item.createTime }} - {{ item.expirationTime }}</div>
                        </div>
                        <div class="t4">
                            <div class="t41"></div>
                            <div class="t42">{{ item.number }} items remaining</div>
                        </div>
                        <div class="t5">
                            <!-- <div class="btn" v-if="item.status == '0'" style="cursor: pointer;">claim</div> -->
                            <div class="btn1" v-if="item.status == '1'">used coupon</div>
                            <div class="btn1" v-if="item.status == '2'">expired coupon</div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- 平台优惠卷列表 -->
            <div class="coupons" v-if="idx == 1">
                <div class="couponsT" :class="item.status == 2 ? 'couponsT1' : ''"
                    v-for="(item, index) in PlatformCouponList" :key="index">
                    <div class="couponsTV">
                        <div class="top">
                            <div class="t1">{{ Number(item.subtractPrice) / Number(item.reachPrice) * 100 }}% OFF</div>
                            <!-- <div class="t2" v-if="item.status == '0'">unused coupon</div>
                            <div class="t22" v-if="item.status == '2' || item.status == '1'"></div> -->
                        </div>
                        <div class="t3">For orders over ${{ item.reachPrice }}</div>
                        <div style="height: 16px;"></div>
                        <div class="t4">
                            <div class="t41"></div>
                            <div class="t42">{{ item.createTime }} - {{ item.expirationTime }}</div>
                        </div>
                        <div class="t4">
                            <div class="t41"></div>
                            <div class="t42">{{ item.number }} items remaining</div>
                        </div>
                        <div class="t5">
                            <div class="btn" v-if="item.status == '0'" style="cursor: pointer;"
                                @click="goGet(item.couponId)">claim</div>
                            <div class="btn1" v-if="item.status == '2' || item.status == '1'">used coupon</div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            idx: 0,
            myCouponList: [],
            PlatformCouponList: [],
            // myCouponList: [{
            //     status: 1,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 1,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 1,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 2,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 2,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 2,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }],
            // PlatformCouponList: [{
            //     status: 1,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 1,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 1,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 2,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 2,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }, {
            //     status: 2,   //1未使用 2使用
            //     t1: '15% OFF',
            //     money: '$199.00',
            //     time: '05/08/2021 04:00 – 09/08/2021 12:00',
            //     num: 5
            // }]
        }
    },
    mounted() {
        this.changeTab(0);
    },
    methods: {
        // 领取优惠券
        async goGet(id) {
            try {
                const res = await this.$post('system/get/getCoupon', {
                    couponId: id
                });
                this.$message({
                    message: res.msg,
                    type: 'success'
                });
                this.changeTab(0);
                // this.myCouponList = res.rows || [];
                // console.warn(res, "查询用户优惠券")
            } catch (error) {
            }
        },
        // 查询用户优惠券
        async listUserCouponApi() {
            try {
                const res = await this.$get('system/get/listUserCoupon', {
                    status: 0,
                    pageSize: 999
                });
                this.myCouponList = res.rows || [];
                console.warn(res, "查询用户优惠券")
            } catch (error) {
            }
        },
        // 平台优惠券 
        async listApi() {
            try {
                const res = await this.$get('system/coupon/list', {
                    pageNum: 1,
                    status: 0,
                    pageSize: 999
                });
                this.PlatformCouponList = res.rows || [];
                console.warn(res, "平台优惠券")
            } catch (error) {
            }
        },
        changeTab(e) {
            if (e == 0) {
                this.listUserCouponApi();
            } else {
                this.listApi();
            }
            this.idx = e;
        }
    },
}
</script>

<style lang='scss' scoped>
.tabV {
    margin-top: 40px;
    display: flex;
    align-items: center;

    .t1 {
        cursor: pointer;
        padding-bottom: 10px;
        // border-bottom: 2px solid #12181D;
        font-size: 20px;
        font-family: Inter, Inter-500;
        font-weight: 500;
        color: #8fa2b2;
    }

    .t2 {
        padding-bottom: 10px;
        border-bottom: 3px solid #12181D;
        cursor: pointer;
        font-size: 20px;
        font-family: Inter, Inter-500;
        font-weight: 500;
        color: #12181d;
    }
}

.coupons {
    padding: 40px 40px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;

    .couponsT1 {
        border: 1px solid #8FA2B2 !important;
    }

    .couponsT {
        margin-right: 40px;
        margin-bottom: 40px;
        width: 420px;
        // height: 243px;
        background: #ffffff;
        border: 1px solid #ff00d7;
        border-radius: 16px;

        .couponsTV {
            width: 100%;
            padding: 20px 20px;

            .top {
                display: flex;
                justify-content: space-between;

                .t1 {
                    font-size: 28px;
                    font-family: Inter, Inter-700;
                    font-weight: 700;
                    color: #12181d;
                }

                .t2 {
                    font-size: 14px;
                    font-family: Inter, Inter-400;
                    font-weight: 400;
                    color: #ffffff;
                    width: 139px;
                    height: 33px;
                    background: #ff00d7;
                    border-radius: 43px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .t22 {
                    width: 139px;
                    height: 33px;
                }
            }

            .t3 {
                margin-top: 5px;
                font-size: 16px;
                font-family: Inter, Inter-500;
                font-weight: 500;
                color: #12181d;
            }

            .t4 {
                margin-top: 16px;
                display: flex;
                align-items: center;

                .t41 {
                    border-radius: 50%;
                    width: 5px;
                    height: 5px;
                    background: #12181D;
                }

                .t42 {
                    margin-left: 10px;
                    font-size: 14px;
                    font-family: Inter, Inter-400;
                    font-weight: 400;
                    color: #12181d;
                }
            }

            .t5 {
                display: flex;
                justify-content: flex-end;
                text-align: right;
                margin-top: 24px;

                .btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 69px;
                    height: 33px;
                    background: #f624d5 linear-gradient(90deg, #f624d5, #3437f7 100%);
                    border-radius: 8px;
                    font-size: 14px;
                    font-family: Inter, Inter-400;
                    font-weight: 400;
                    color: #ffffff;
                }

                .btn1 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 138px;
                    height: 33px;
                    background: #cccccc;
                    border-radius: 8px;
                    font-size: 14px;
                    font-family: Inter, Inter-400;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }
    }
}
</style>